module.exports = __webpack_public_path__ + "static/5-trends-f14bbc3d5c692966878770adeed14680.png";